import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AccountProvider } from './context/AccountContext';
import Layout from './components/Layout';
import PaymentFlow from './pages/PaymentFlow';
import TransactionList from './pages/TransactionList';
import AccountCenter from './pages/AccountCenter';
import PaymentProcessNaked from './pages/PaymentFlow/PaymentProcessNaked'; // Import the new component
import AccountOpen from './pages/AccountOpen';
import './styles/global.css';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <AccountProvider>
        <Router>
          <Routes>
            {/* Routes that do NOT use the main layout */}
            <Route path="/payment-process/*" element={<PaymentProcessNaked />} />
            <Route path="/account-open/*" element={<AccountOpen />} />

            {/* Routes that DO use the main layout */}
            <Route path="/" element={<Layout><Navigate to="/account/unregistered" replace /></Layout>} />
            <Route path="/account/*" element={<Layout><AccountCenter /></Layout>} />
            <Route path="/transactions" element={<Layout><TransactionList /></Layout>} />
            <Route path="/bill-query" element={<Layout><TransactionList /></Layout>} />
            <Route path="/payment/*" element={<Layout><PaymentFlow /></Layout>} />
          </Routes>
        </Router>
      </AccountProvider>
    </ConfigProvider>
  );
}

export default App;
